import { defineMessages } from "react-intl";

import { node as abdominalCt } from "src/modules/ltx/forms/phase-i/imaging-procedures/abdominalCt";
import { node as abdominalMri } from "src/modules/ltx/forms/phase-i/imaging-procedures/abdominalMri";
import { node as abdominalUltrasound } from "src/modules/ltx/forms/phase-i/imaging-procedures/abdominalUltrasound";
import { node as chestCt } from "src/modules/ltx/forms/phase-i/imaging-procedures/chestCt";
import { node as chestXray } from "src/modules/ltx/forms/phase-i/imaging-procedures/chestXRay";
import { node as craniumCt } from "src/modules/ltx/forms/phase-i/imaging-procedures/craniumCt";
import { node as craniumMr } from "src/modules/ltx/forms/phase-i/imaging-procedures/craniumMr";
import { node as gastroscopia } from "src/modules/ltx/forms/phase-i/imaging-procedures/gastroscopia";
import { node as lumbarSpineXRay } from "src/modules/ltx/forms/phase-i/imaging-procedures/lumbarSpineXRay";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.imaging_procedures",
		defaultMessage: "Képalkotó vizsgálatok"
	}
});

export const node: ParentNode = {
	id: "imagingProcedures",
	value: { type: "wizard", title: messages.title },
	children: [
		chestXray,
		chestCt,
		abdominalUltrasound,
		abdominalCt,
		abdominalMri,
		lumbarSpineXRay,
		gastroscopia,
		craniumCt,
		craniumMr
	]
};
